import { OtherExplanationSchema } from '@Containers/OtherExplanations/validators';
import { z } from 'zod';

export const FinancialStatementsSchema = z.object({
  otherDescriptions: z.array(OtherExplanationSchema).optional(),
});
